import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Firebase configuration - uses environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
};

// Check if we're running on Firebase Hosting (auto-config available)
const isFirebaseHosting = typeof window !== 'undefined' &&
  window.location.hostname.includes('web.app') ||
  window.location.hostname.includes('firebaseapp.com');

// Initialize Firebase - only if not already initialized
const app = getApps().length === 0
  ? initializeApp(isFirebaseHosting ? {} : firebaseConfig)
  : getApp();

export const auth = getAuth(app);
export const storage = getStorage(app);

// Connect to emulators in development
if (import.meta.env.DEV && !isFirebaseHosting) {
  const useEmulators = localStorage.getItem('useEmulators') === 'true';
  if (useEmulators) {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectStorageEmulator(storage, 'localhost', 9199);
  }
}

export default app;
